import React, { useEffect, useRef, useState } from "react";
import SideMenu from "./../../../sharedScreens/menuItems/SideMenu";
import { MuiInput } from "./../../../components/basicComponent/MuiInput";
import MuiButton from "./../../../components/basicComponent/MuiButton";
import Header from "./../../../sharedScreens/Header";
import MuiDatePicker from "./../../../components/basicComponent/MuiDatePicker";
import { useFormik } from "formik";
import dayjs, { Dayjs } from "dayjs";
import { PaymentMode, PaymentStatusOptions } from "../../../constants/constant";
import { MuiDropDown } from "../../../components/basicComponent/MuiDropDown";
import { UtilService } from "../../../services/shared/UtilService";
import { msgTypes } from "../../../constants/msgTypes";
import { OTPAction } from "../../../constants/enum";
import { Box, InputLabel, TextField } from "@mui/material";
import UserListFilter from "../../../components/composite/UserListFilter";
import {
  capitalizeFirstLetter,
  removeUnderscores,
} from "../../../constants/helper";
import ConfirmationModal from "../../../components/basicComponent/ConfirmationModal";
import { useGlobalState } from "../../../services/context/AuthContext";
import { userInfo } from "os";
import { response } from "express";
import NoDataFlightCard from "../../../components/composite/NoDataFlightCard";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import MuiSearchSelect from "../../../components/basicComponent/MuiSearchSelect";
import { useSweetAlert } from "../../../services/customHooks/useSweetAlert";
import { stat } from "fs";
const RESEND_COOLDOWN = 60; // 1 minute cooldown

const FilterPopUp = ({
  onVerify,
  onClose,
  onResend,
  isWrongOtpEntered,
  id,
}: {
  onVerify: (otp: boolean) => void;
  onClose: () => void;
  onResend?: () => void;
  isWrongOtpEntered?: boolean;
  id: any;
}) => {
  const { userInfo } = useGlobalState();
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputRefs = useRef<HTMLInputElement[]>([]);
  const [timer, setTimer] = useState(RESEND_COOLDOWN);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleChange = (value: string, index: number) => {
    if (!/^\d*$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    setError(null); // reset error on change

    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent, index: number) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleResend = () => {
    if (timer === 0) {
      onResend?.();
      setOtp(new Array(6).fill(""));
      setError(null);
      setTimer(RESEND_COOLDOWN);
    }
  };

  const handleVerify = async () => {
    if (otp.some((digit) => digit === "")) {
      setError("Please enter all 6 digits of the OTP.");
      return;
    } else {
      const finalOtp = otp.join("");
      const payload = {
        action: OTPAction.VERIFY_ADMIN_OTP,
        otp_code: finalOtp,
      };

      try {
        setError(null);
        const response = await UtilService.verifyUserOtp(id, payload);
        if (!!response.data) {
          onVerify(!!response.data);
        }
      } catch (error) {
        setError("Incorrect OTP. Please try again.");
      }
    }

    // Simulated incorrect OTP check
    // const joinedOtp = otp.join("");
    // const fakeCorrectOtp = "123456"; // replace with real verification in production
    // if (isWrongOtpEntered) {
    //   setError("Incorrect OTP. Please try again.");
    //   return;
    // }
  };

  return (
    <div className="card-body p-0 pb-n3">
      <InputLabel>Verify OTP Sent to {`${userInfo?.email}`}</InputLabel>
      <Box display="flex" gap={0.5} mt={1}>
        {otp.map((digit, index) => (
          <TextField
            key={index}
            inputRef={(el) => (inputRefs.current[index] = el!)}
            value={digit}
            onChange={(e) => handleChange(e.target.value, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            variant="outlined"
            inputProps={{
              maxLength: 1,
              style: {
                textAlign: "center",
                fontSize: "20px",
                width: "20px",
                height: "20px",
              },
            }}
          />
        ))}
      </Box>

      {error && (
        <p style={{ color: "red", marginTop: "8px", fontSize: "14px" }}>
          {error}
        </p>
      )}

      <div className="mt-2">
        <button
          className={`text-sm underline ${
            timer === 0
              ? "text-primary text-decoration-underline"
              : "text-blue-500"
          }`}
          onClick={handleResend}
          disabled={timer > 0}
          style={{ background: "none", border: "none" }}
        >
          {timer > 0 ? `Resend OTP in ${timer}s` : "Resend OTP"}
        </button>
      </div>

      <div className="text-sm ms-1 text-muted">
        <strong>Note:</strong> This OTP is valid for 10 minutes
      </div>

      <div className="user-button mt-4">
        <MuiButton
          className="clear-btn"
          label="Cancel"
          type="submit"
          style={{ width: "38%" }}
          onClick={onClose}
        />
        <MuiButton
          className="get-btn"
          label="Submit"
          type="submit"
          style={{ width: "36%" }}
          onClick={handleVerify}
        />
      </div>
    </div>
  );
};
const ITEMS_PER_PAGE = 10;
const UpdateTopupRequest = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(ITEMS_PER_PAGE);
  const { userInfo } = useGlobalState();
  const [companyList, setCompanyList] = useState<[]>([]);
  const [open, setOpen] = useState<boolean>(false);
  const [list, setList] = useState<[]>([]);
  const [confirmationModal, setConfirmationModal] = useState<boolean>(false);
  const [adminRemark, setAdminRemark] = useState<string>();
  const [errorText, setErrorText] = useState<string | undefined>();
  const [otp, setOtp] = useState([""]);
  const [currentOtpItemId, setCurrentOtpItemId] = useState("");
  const [confirmationItemId, setConfirmationItemId] = useState<string>("");
  const [isWrongOtp, setIsWrongOtp] = useState<boolean>(false);
  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: "asc" | "desc";
  }>({ key: "", direction: "asc" });
  const { showSuccess, showError, showInfo } = useSweetAlert();
  const initialValues = {
    customerName: "",
    status: "",
    payment_mode: "",
    from_date: null,
    to_date: null,
    requestId: "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    onSubmit(values, formikHelpers) {
      console.log("values--------", values);
    },
  });

  const getSortedAndPagedData = () => {
    let sorted = [...list];

    if (sortConfig.key) {
      sorted.sort((a: any, b: any) => {
        const aTime = new Date(a[sortConfig.key]).getTime();
        const bTime = new Date(b[sortConfig.key]).getTime();
        return sortConfig.direction === "asc" ? aTime - bTime : bTime - aTime;
      });
    }

    return sorted.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );
  };

  const currentData = getSortedAndPagedData();
  const handleSort = (key: string) => {
    setSortConfig((prev) => {
      const direction =
        prev.key === key && prev.direction === "asc" ? "desc" : "asc";
      return { key, direction };
    });
  };

  useEffect(() => {
    getCompanyList();
    getListOfTopupRequest();
  }, []);

  const getCompanyList = async (filterPayload?: {}) => {
    const response = await UtilService.getBusinessName();
    if (response.statusMsg === msgTypes.SUCCESS.msg) {
      const arr = response?.data?.map((i: { businessName: any; id: any }) => ({
        id: i?.id,
        label: i?.businessName,
        value: i?.businessName,
      }));
      setCompanyList(arr);
    }
  };

  const getListOfTopupRequest = async (params?: any) => {
    setLoading(true); // Start loader
    try {
      const response = await UtilService.getTopupRequestList(params);
      if (response?.data) {
        setList(response.data);
      } else {
        setList([]);
      }
    } catch (err) {
      console.error("Failed to fetch top-up list", err);
      showError("Oops...", "Failed to fetch data.");
    } finally {
      setLoading(false); // End loader
    }
  };

  const initiateApprovePayment = async (id: string) => {
    const payload = {
      action: OTPAction.INITIATE_ADMIN_OTP,
    };
    setOpen(true);

    const response = await UtilService.verifyUserOtp(id, payload);
  };

  const approvePayment = async (otp: boolean) => {
    if (otp) {
      setOpen(false);
      getListOfTopupRequest();
      showSuccess("Success!", "Topup Request has been Approved successfully.", {
        timer: 3000,
        timerProgressBar: true,
      });
    }
  };
  const closeOtpModal = () => {
    setOpen(false);
    setIsWrongOtp(false); // ✅ reset state to avoid showing old error
    getListOfTopupRequest();
  };

  const rejectPayment = async (id: string) => {
    const payload = {
      action: OTPAction.REJECT,
      admin_note: adminRemark,
    };
    const response = await UtilService.verifyUserOtp(
      confirmationItemId,
      payload
    );
    if (!!response?.data) {
      setConfirmationModal(false);
      getListOfTopupRequest();
      showSuccess("Success!", "Topup Request has been Rejected successfully.", {
        timer: 3000,
        timerProgressBar: true,
      });
    } else {
      showError(
        "Oops...",
        response?.statusRemark ?? "Something went wrong while rejecting!"
      );
    }
  };


  const handleConfirmationModal = () => {
    setConfirmationModal(true);
  };
  const resendOtp = async (id: string) => {
    const payload = {
      action: OTPAction.RESEND_ADMIN_OTP,
    };
    const res = await UtilService.resendUserOtp(id, payload);
    if (!!res?.data) {
      setOpen(true);
    }
  };

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="row">
              <div className="col-md-12">
                <div className="card card-custom">
                  <div className="card-body">
                    <div className="row">
                      <div className="card-header text-center">
                        <h3 className="card-title">Filter</h3>
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiSearchSelect
                          placeholder={"Customer Name"}
                          label="Customer Name"
                          options={companyList}
                          value={formik.values.customerName}
                          onChange={(value) =>
                            formik.setFieldValue("customerName", value)
                          }
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiDropDown
                          placeholder={"Payment Status "}
                          label="Payment Status "
                          options={PaymentStatusOptions}
                          value={formik.values.status}
                          onChange={(value) =>
                            formik.setFieldValue("status", value)
                          }
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiDropDown
                          label={"Payment Mode"}
                          placeholder="Payment Mode"
                          options={PaymentMode}
                          value={formik.values.payment_mode}
                          onChange={(value) =>
                            formik.setFieldValue("payment_mode", value)
                          }
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiDatePicker
                          label="From Date"
                          value={
                            formik.values.from_date
                              ? dayjs(formik.values.from_date)
                              : null
                          }
                          onChange={(value) =>
                            formik.setFieldValue("from_date", value)
                          }
                          isDisablePastDate={false}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiDatePicker
                          label="To Date"
                          value={
                            formik.values.to_date
                              ? dayjs(formik.values.to_date)
                              : null
                          }
                          onChange={(value) =>
                            formik.setFieldValue("to_date", value)
                          }
                          isDisablePastDate={false}
                        />
                      </div>
                      {/* <div className="col-md-4 mt-3">
                        <MuiInput
                          placeholder={"Request ID*"}
                          label="Request ID"
                          value={formik.values.requestId}
                          onChange={(value) =>
                            formik.setFieldValue("requestId", value)
                          }
                        />
                      </div> */}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                        marginTop: "8px",
                      }}
                    >
                      <div className="user-button w-full">
                        <MuiButton
                          className="clear-btn "
                          label="Clear"
                          onClick={() => {
                            if (
                              !formik.values.to_date &&
                              !formik.values.from_date &&
                              !formik.values.payment_mode &&
                              !formik.values.status &&
                              !formik.values.customerName
                            ) {
                              showInfo("", "Nothing to clear");
                            } else {
                              formik.setValues(initialValues).then(() => {
                                getListOfTopupRequest();
                              });
                            }
                          }}
                        />

                        <MuiButton
                          className="main-btn get-btn"
                          variant="contained"
                          size="large"
                          type="submit"
                          label={"Get"}
                          onClick={() => {
                            if (
                              !formik.values.to_date &&
                              !formik.values.from_date &&
                              !formik.values.payment_mode &&
                              !formik.values.status &&
                              !formik.values.customerName
                            ) {
                              showInfo(
                                "",
                                "Please select at least one filter before submitting."
                              );
                            } else {
                              getListOfTopupRequest({ ...formik.values });
                            }
                          }}
                        />
                      </div>
                    </div>

                    <div className="row mt-4">
                      {loading ? (
                        <div className="text-center my-5 w-full">
                          <span
                            className="spinner-border text-primary"
                            role="status"
                          />
                          <p className="mt-2">Loading top-up requests...</p>
                        </div>
                      ) : (
                        list?.length > 0 && (
                          <>
                            <div className="card-header text-center">
                              <h3 className="card-title">
                                Update Topup Request
                              </h3>
                            </div>
                            <div className="table-responsive">
                              <table className="table table-bordered  table-hover align-middle">
                                <thead className="table-dark">
                                  <tr>
                                    <th>Reference ID</th>
                                    <th>User</th>
                                    <th>Amount</th>
                                    <th>Top-up Type</th>

                                    <th>Payment Mode</th>
                                    <th>Requested By</th>
                                    {<th>Admin Note</th>}
                                    <th>Opening Balance</th>
                                    <th>Closing Balance</th>
                                    <th
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handleSort("createdAt")}
                                    >
                                      Created At{" "}
                                      {sortConfig.key === "createdAt"
                                        ? sortConfig.direction === "asc"
                                          ? "↑"
                                          : "↓"
                                        : ""}
                                    </th>

                                    <th
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handleSort("updatedAt")}
                                    >
                                      Updated At{" "}
                                      {sortConfig.key === "updatedAt"
                                        ? sortConfig.direction === "asc"
                                          ? "↑"
                                          : "↓"
                                        : ""}
                                    </th>

                                    <th>Status</th>
                                    {<th>Actions </th>}
                                  </tr>
                                </thead>

                                {/* Sample row */}
                                <tbody>
                                  {currentData?.length > 0 ? (
                                    currentData?.map((item: any, index) => (
                                      <tr key={item.id} className="text-color ">
                                        <td>{item.referenceId}</td>
                                        <td className="text-capitalize">
                                          {item.businessName}
                                        </td>
                                        <td>{item.amount}</td>
                                        <td>{item.topupType}</td>
                                        <td className="text-capitalize">
                                          {item.paymentMode}
                                        </td>
                                        <td className="text-capitalize">
                                          {item.requestedByName}
                                        </td>
                                        {
                                          <td
                                            className="text-capitalize"
                                            style={{
                                              whiteSpace: "wrap",
                                              minWidth: "596px",
                                            }}
                                          >
                                            {item.adminNote || ""}
                                          </td>
                                        }
                                        <td>{item.openingBalance}</td>
                                        <td>{item.closingBalance}</td>
                                        <td>
                                          {new Date(
                                            item.createdAt
                                          ).toLocaleString()}
                                        </td>
                                        <td>
                                          {new Date(
                                            item.updatedAt
                                          ).toLocaleString()}
                                        </td>
                                        <td
                                          className="text-capitalize"
                                          style={{
                                            color:
                                              item.status === "approved"
                                                ? "green"
                                                : item.status === "pending"
                                                ? "orange"
                                                : item.status === "rejected"
                                                ? "#e33a3acc"
                                                : "#64638e",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {removeUnderscores(
                                            capitalizeFirstLetter(item.status)
                                          )}
                                        </td>
                                        {
                                          <td>
                                            <div className="d-flex gap-2">
                                              {item.status ===
                                                "admin_review" && (
                                                <button
                                                  type="button"
                                                  className="btn btn-sm btn-success"
                                                  onClick={() => {
                                                    setCurrentOtpItemId(
                                                      item?.id
                                                    );
                                                    initiateApprovePayment(
                                                      item.id
                                                    );
                                                  }}
                                                >
                                                  Approve
                                                </button>
                                              )}
                                              {item.status ===
                                                "admin_review" && (
                                                <button
                                                  type="button"
                                                  className="btn btn-sm btn-danger"
                                                  onClick={() => {
                                                    setConfirmationItemId(
                                                      item?.id
                                                    );
                                                    handleConfirmationModal();
                                                  }}
                                                >
                                                  Reject
                                                </button>
                                              )}
                                            </div>
                                            <div className="d-flex justify-content-center">
                                              {item.status ===
                                                "admin_otp_pending" && (
                                                <button
                                                  type="button"
                                                  className="btn btn-sm btn-primary "
                                                  onClick={() => {
                                                    setCurrentOtpItemId(
                                                      item?.id
                                                    );
                                                    resendOtp(item?.id ?? "");
                                                  }}
                                                >
                                                  Resend OTP
                                                </button>
                                              )}
                                            </div>
                                          </td>
                                        }
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <NoDataFlightCard
                                        headingText="No Data Found"
                                        icon={
                                          <SearchOffIcon
                                            fontSize="large"
                                            className="text-gray-500"
                                          />
                                        }
                                        paragraph=""
                                      />
                                    </tr>
                                  )}
                                  <ConfirmationModal
                                    handleClose={() => {
                                      setConfirmationModal(false);
                                    }}
                                    header="Are you sure you want to Reject?"
                                    isVisible={confirmationModal}
                                    onConfirm={() => {
                                      if (confirmationItemId && !!adminRemark) {
                                        rejectPayment(confirmationItemId);
                                        setErrorText(undefined);
                                      } else {
                                        setErrorText(
                                          "Please enter remark before rejecting"
                                        );
                                      }
                                    }}
                                    subText={""}
                                    children={
                                      <>
                                        {/* <MuiInput
                                        label={"Remark"}
                                        placeholder="Remark"
                                        value={adminRemark}
                                        onChange={(val) => setAdminRemark(val)}
                                      /> */}
                                        <TextareaAutosize
                                          className="update-popup"
                                          aria-label="empty textarea"
                                          minRows={3} // ✅ This increases the initial height
                                          placeholder="Remark"
                                          value={adminRemark}
                                          onChange={(e) => {
                                            setAdminRemark(e.target.value);
                                            setErrorText(undefined);
                                          }}
                                          style={{
                                            marginTop: "-16px",
                                            border: errorText
                                              ? "1px solid #ec5151"
                                              : "1px solid #ccc", // 🔴 Conditionally apply red border
                                            width: 320,
                                            padding: "6px",
                                          }}
                                        />
                                        {errorText && (
                                          <p
                                            style={{
                                              position: "absolute",
                                              left: "45px",
                                              color: "#ec5151",
                                              fontSize: "14px",
                                            }}
                                          >
                                            {errorText}
                                          </p>
                                        )}
                                      </>
                                    }
                                  />

                                  <UserListFilter
                                    header={`Verify OTP `}
                                    children={
                                      <FilterPopUp
                                        isWrongOtpEntered={isWrongOtp}
                                        onVerify={approvePayment}
                                        onClose={closeOtpModal}
                                        onResend={() => {
                                          if (currentOtpItemId)
                                            resendOtp(currentOtpItemId);
                                        }}
                                        id={currentOtpItemId}
                                      />
                                    }
                                    isVisible={open}
                                    handleClose={closeOtpModal}
                                  />
                                </tbody>

                                {/* Add more rows dynamically */}
                              </table>
                            </div>
                            <div className="card-footer flex justify-between items-center">
                              <div className="pagination">
                                <button
                                  className="btn"
                                  onClick={() =>
                                    handlePageChange(currentPage - 1)
                                  }
                                  disabled={currentPage === 1}
                                >
                                  <i className="ki-outline ki-black-left rtl:transform rtl:rotate-180"></i>
                                </button>
                                <button className="btn active disabled">
                                  {currentPage}
                                </button>
                                <button
                                  className="btn"
                                  onClick={() =>
                                    handlePageChange(currentPage + 1)
                                  }
                                  disabled={
                                    currentPage * itemsPerPage >= list.length
                                  }
                                >
                                  <i className="ki-outline ki-black-right rtl:transform rtl:rotate-180"></i>
                                </button>
                              </div>
                            </div>
                          </>
                        )
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default UpdateTopupRequest;
